export class HealthEvent {
  idEvento: number
  nombreEvento: string;

  constructor(hEvent: HealthEvent) {
    this.idEvento = hEvent.idEvento || 0;
    this.nombreEvento = hEvent.nombreEvento || '';
  }

}
